var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_vm.isMain ? [_c('lecture-main')] : [_c('lecture-list', _vm._b({}, 'lecture-list', {
    category: _vm.category,
    isStream: _vm.isStream,
    isMiceNow: _vm.isMiceNow
  }, false))]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }